export default {
    maxContentWidth: '1920px',
    headerHeight: 154, // component + margins (8+8)
    headerHeightMobile: 120, // component + margins (8+8)
    overlayBodyTitleHeight: 50,
} as const;
